import React from 'react';
import classNames from 'classnames';

import styles from './Flex.module.css';

interface Props {
  direction?: 'row' | 'column';
  align?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around';
  wrap?: 'wrap' | 'nowrap' | 'wrap-reversed';
  flex?: number | string;
  style?: React.CSSProperties;
  gap?: number;
  className?: string;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Flex = React.forwardRef<HTMLDivElement, Props>(
  (
    { direction, align, justify, wrap, flex, gap, style, className, children, ...rest },
    ref
  ) => {
    // CSS custom properties inherit through the DOM, so every property must be
    // set explicitly here (even to its default) — otherwise a nested Flex would
    // pick up a value set by an ancestor Flex instead of falling back to its own default.
    const customProperties = {
      '--direction': direction === 'column' ? 'column' : 'row',
      '--align': align || 'initial',
      '--justify': justify || 'initial',
      '--flex': flex || 'initial',
      '--wrap': wrap || 'initial',
      '--gap': gap ? `${gap}px` : 'initial',
    } as React.CSSProperties;

    return (
      <div
        ref={ref}
        className={classNames(styles.flex, className)}
        style={{ ...customProperties, ...style }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default Flex;
